export default __webpack_public_path__ + "static/media/DafiPolygenLoader.bcbc5f13.gif";